
class Library{
    init()
    {
        const libraryHelperSubmit = document.getElementById("libraryHelperSubmit");
        if(libraryHelperSubmit != null){
            libraryHelperSubmit.addEventListener('click', this.helperLinkClick);
        }
        const libraryChatNow = document.querySelectorAll('.libraryRegEChatBtn');
        if(libraryChatNow){
            if(libraryChatNow.length > 0){
                this.loadScript();
                libraryChatNow.forEach(lib  =>{
                    let libBtn = lib as HTMLAnchorElement;
                    libBtn.style.display = 'none';
                    
                });
            }
        }
    }

    async loadScript() {
        try {
            await this.loadChatWidgetScript();
            this.observeLibraryChatBtns();
        } catch (error) {
            console.error('Error loading chat widget script:', error);
        }
    }
    loadChatWidgetScript(): Promise<void> {
        return new Promise((resolve, reject) => {
            // const existingScript = document.querySelector('script[src="https://ca.libraryh3lp.com/js/libraryh3lp.js?10456"]');
            const existingScript = document.querySelector('script[src="https://sait.libanswers.com/load_chat.php?hash=45c320a7145b49baa8fa273296b83d27ff872ee41b2ca4b580106c63b14221da"]');
            if (existingScript) {
                resolve();
                return;
            }

            let chatWidgetScript = document.createElement('script');
            // chatWidgetScript.src = 'https://ca.libraryh3lp.com/js/libraryh3lp.js?10456';
            chatWidgetScript.src = 'https://sait.libanswers.com/load_chat.php?hash=45c320a7145b49baa8fa273296b83d27ff872ee41b2ca4b580106c63b14221da';
            chatWidgetScript.async = true;
            if (document.body) {
                document.body.appendChild(chatWidgetScript);
            }
            chatWidgetScript.onload = () => {
                resolve();
            };
    
            chatWidgetScript.onerror = () => {
                reject(new Error('Failed to load the script.'));
            };

        });
    }

    observeLibraryChatBtns() {
        const targetNode = document.querySelector('.libraryChatWidgetWrapper');
        if (targetNode) {
            const observer = new MutationObserver((mutations, obs) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        this.handleLibraryChatBtns(obs);
                    }
                });
            });
            observer.observe(targetNode, {
                childList: true,
                subtree: true
            });
        }
    }    

    //To handle dom elements added from the Library script. 
    //To add class to the third party library button for styling
    //Check if the library chat is offline hide the CMS content when it's offline. Library has it's own offline message from script.
    handleLibraryChatBtns(observer : MutationObserver) {
        // let libraryChatContainers = document.querySelectorAll('.libraryh3lp');
        let libraryChatContainers = document.querySelectorAll('libchat_45c320a7145b49baa8fa273296b83d27ff872ee41b2ca4b580106c63b14221da');
        let isOffline = false;
        const checkLibraryStatus = (container: Element) => {
            let chatOffContainer = container.querySelector('div.chatoff');
            if (chatOffContainer) {
                let parentDiv = chatOffContainer.parentElement as HTMLDivElement;
                if (parentDiv === container) { // Ensure it's the direct parent
                    let computedStyle = getComputedStyle(parentDiv);
                    if (computedStyle.display === 'none') {
                        isOffline = true;
                        console.log('Library is offline');
                    }
                }
            }
    
            let anchor = container.querySelector('a');
            if (anchor) {
                if (!anchor.href.includes('sait.libcal.com/hours')) {
                    let pTag = anchor.querySelector('p.chatbutton');
                    if (pTag) {
                        pTag.remove();
                    }
                    anchor.text = "Chat now";
                    anchor.classList.add('btn', 'btn-primary');
                }
            }
        };
    
        if (libraryChatContainers.length > 0) {
            libraryChatContainers.forEach(container => {
                checkLibraryStatus(container);
            });
    
            let onlineChatMessage = document.querySelector('#libOnlineMessage') as HTMLElement;
            if (onlineChatMessage) {
                if (isOffline) {
                    onlineChatMessage.style.display = 'none';
                } else {
                    onlineChatMessage.style.display = 'block';
                }
            }
    
            // Disconnect the observer after processing
            observer.disconnect();
        } else {
            // Disconnect the observer if no containers are found
            observer.disconnect();
        }
    }

    helperLinkClick = () => {
        const libraryLink =  document.getElementById("libECorrLink") as HTMLLinkElement;
        const textCopyLink = document.getElementById("libECorrInput") as HTMLInputElement;
        if(libraryLink !== null){
            if(textCopyLink.value){
                let linkVal = libraryLink.href + textCopyLink.value;
                let copylink = document.getElementById("copylink");
                copylink.innerText = linkVal;
            }
        }
    }
}
export default Library;